import n2words from "n2words";

export default function convertCurrency(value) {
  const result = !!value || value === 0 ? n2words(value, { lang: "vi" }) : "Not found";
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export const convertIntMoney = (value) => {
  if (isNaN(value)) return 0;
  return new Intl.NumberFormat("vi-VN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
